import React, { Component } from 'react';
import { StepPage } from '../../controls/StepPage';
import orderService from '../OrderService';
import { EardrumCheckBoxGroup } from './EardrumCheckBoxGroup';
import { FormattedMessage } from 'react-intl';
import { LeftRightOption } from '../../infrastructure/AppConstants';
export class EarmoldStep5Page extends StepPage {

    constructor(props) {
        super(props);
        this.state = { data: null};
        this.handleEardrumBteVents = this.handleEardrumBteVents.bind(this);
        this.handleEarmoldBteTubeDiameters = this.handleEarmoldBteTubeDiameters.bind(this);
        this.handleEarmoldBteLengths = this.handleEarmoldBteLengths.bind(this);
        this.handleEarmoldBteTubeLengths = this.handleEarmoldBteTubeLengths.bind(this);
        this.handleEarmoldRicReceiverVersions = this.handleEarmoldRicReceiverVersions.bind(this);
        this.handleEardrumRicVents = this.handleEardrumRicVents.bind(this);
        this.handleEardrumRicCordLengths = this.handleEardrumRicCordLengths.bind(this);
        this.handleEardrumRicReceivers = this.handleEardrumRicReceivers.bind(this);
        this.handleEardrumRicCords = this.handleEardrumRicCords.bind(this);
    }


    handleEardrumBteVents(e) {
        if (this.props.model) {
            this.props.model.eardrumBteVent = e;
        }
    }

    handleEarmoldBteTubeDiameters(e) {
        if (this.props.model) {
            this.props.model.earmoldBteTubeDiameter = e;
        }
    }
    handleEarmoldBteLengths(e) {
        if (this.props.model) {
            this.props.model.earmoldBteLength = e;
        }
    }
    handleEarmoldBteTubeLengths(e) {
        if (this.props.model) {
            this.props.model.earmoldBteTubeLength = e;
        }
    }

    handleEarmoldRicReceiverVersions(e) {
        if (this.props.model) {
            this.props.model.earmoldRicReceiverVersion = e;
        }
    }

    handleEardrumRicVents(e) {
        if (this.props.model) {
            this.props.model.eardrumRicVent = e;
        }
    }
    handleEardrumRicCordLengths(e) {
        if (this.props.model) {
            this.props.model.eardrumRicCordLength = e;
        }
    }
    handleEardrumRicReceivers(e) {
        if (this.props.model) {
            this.props.model.eardrumRicReceiver = e;
        }
    }
    handleEardrumRicCords(e) {
        if (this.props.model) {
            this.props.model.eardrumRicCord = e;
        }
    }

    validate() {
        let model = this.props.model;
        let type = model.bteOrRic;
        
        if (type === "RIC" || type === "IF") {
            let isIF = type === "IF";
            let leftRightOption = this.props.leftRightOption;            
            if (leftRightOption === LeftRightOption.LeftEarOption) {
                if (isIF) {
                   
                }
                else {
                    if (!model.eardrumRicReceiver || model.eardrumRicReceiver.startsWith("-1")) {
                        return { state: false, msg: "EardrumRicReceiverRequired" };
                    }

                    if (!model.eardrumRicCordLength || model.eardrumRicCordLength.startsWith("-1")) {
                        return { state: false, msg: "EardrumRicCordLengthRequired" };
                    }
                }
            }
            else if (leftRightOption === LeftRightOption.RightEarOption) {
                if (isIF) {
                  
                }
                else {
                    if (!model.eardrumRicReceiver || model.eardrumRicReceiver.endsWith("-1")) {
                        return { state: false, msg: "EardrumRicReceiverRequired" };
                    }

                    if (!model.eardrumRicCordLength || model.eardrumRicCordLength.endsWith("-1")) {
                        return { state: false, msg: "EardrumRicCordLengthRequired" };
                    }
                }
            }
            else if (leftRightOption === LeftRightOption.BothEarsOption) {
                if (isIF) {
                   
                }
                else {
                    if (!model.eardrumRicReceiver || model.eardrumRicReceiver.includes("-1")) {
                        return { state: false, msg: "EardrumRicReceiverRequired" };
                    }

                    if (!model.eardrumRicCordLength || model.eardrumRicCordLength.includes("-1")) {
                        return { state: false, msg: "EardrumRicCordLengthRequired" };
                    }
                }                
            }
        }
        else if (type === "BTE") {
            let version = model.earmoldVersion;
            if (version.startsWith("3.0")) {
                let leftRightOption = this.props.leftRightOption;
                if (leftRightOption === LeftRightOption.LeftEarOption) {
                    if (!model.earmoldBteTubeLength || model.earmoldBteTubeLength.startsWith("-1")) {
                        return { state: false, msg: "EarmoldBteTubeLengthRequired" };
                    }                   
                }
                else if (leftRightOption === LeftRightOption.RightEarOption) {
                    if (!model.earmoldBteTubeLength || model.earmoldBteTubeLength.endsWith("-1")) {
                        return { state: false, msg: "EarmoldBteTubeLengthRequired" };
                    }                    
                }
                else if (leftRightOption === LeftRightOption.BothEarsOption) {
                    if (!model.earmoldBteTubeLength || model.earmoldBteTubeLength.includes("-1")) {
                        return { state: false, msg: "EarmoldBteTubeLengthRequired" };
                    }                   
                }
            }
        }
        return { state: true, msg: "todo check page5" };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        let data = await orderService.populateEarmoldProductOptionData();
                              
        this.setState({ data: data });
    }

    filterOptionsByEarmoldVersion(options, vertionCode) {
        if(vertionCode){
            return options.filter(x => orderService.isLinkToEarmoldVerion(x.id, vertionCode));
        }
        
        return options;
    }

    parseGetVersionCode(version) {
        let vString = "";
        if (version) {
            let arr = version.split(',');
            if (arr.length == 2) {
                return arr[1];
            }
        }
       
        return vString;
    }

    render() {

        let data = this.state.data;
        if (!data) {
            return null;
        }

        let model = this.props.model;        
        if (!model) {
            return null;
        }

        let version = model.earmoldVersion;
        let versionCode = this.parseGetVersionCode(model.earmoldVersion);
        let type = model.bteOrRic;
        let isIF = type === "IF";
        if (type === "IF") {
            let eardrumRicVents = this.filterOptionsByEarmoldVersion(data.eardrumRicVents, versionCode);
            return <div className="flex flex-col gap-6"><div className="flex gap-6">
               
                <div>
                    <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption} title="Vent" className="text-sm border-2 border-blue-200" header="IF" desc="IFEardrumRicVentDesc" items={eardrumRicVents}
                        onSelectValueChanged={this.handleEardrumRicVents} value={model.eardrumRicVent} />
                </div>
                
               
            </div>
                <div className="w-1/2">
                    <div className="text-xxs text-red-500">
                        <span className="text-xs text-red-600 font-bold">
                            <FormattedMessage id="OrderFillingInstructions" />
                        </span>
                        <FormattedMessage id="EardrumFillingInstructionsContent" />
                    </div>
                    <div colSpan="3" className="text-xxs text-gray-500 italic ">
                        <FormattedMessage id="EardrumOrderFillingInstructionsClaim" />
                    </div>
                </div>
            </div>
        }
        else if (type === "RIC") {
            let eardrumRicReceivers = this.filterOptionsByEarmoldVersion(data.eardrumRicReceivers, versionCode);
            let eardrumRicVents = this.filterOptionsByEarmoldVersion(data.eardrumRicVents, versionCode);
            let eardrumRicCordLengths = this.filterOptionsByEarmoldVersion(data.eardrumRicCordLengths, versionCode); 
            let eardrumRicCords = this.filterOptionsByEarmoldVersion(data.eardrumRicCords, versionCode);

            return <div className="flex flex-col gap-6"><div className="flex gap-6">
                <div>
                    <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption} isIF={ isIF}  title="EardrumRicReceiver" className="text-sm border-2 border-blue-200" header="RIC" desc="EardrumRicReceiverDesc" items={eardrumRicReceivers}
                        onSelectValueChanged={this.handleEardrumRicReceivers} value={model.eardrumRicReceiver} />
                </div>
                <div>
                    <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption}  title="Vent" className="text-sm border-2 border-blue-200"  header="RIC" desc="EardrumRicVentDesc" items={eardrumRicVents}
                        onSelectValueChanged={this.handleEardrumRicVents} value={model.eardrumRicVent} />
                </div>
                <div>
                    <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption} isIF={isIF} title="EardrumRicCordLength" className="text-sm border-2 border-blue-200"  header="RIC" desc="EardrumRicCordLengthDesc" items={eardrumRicCordLengths}
                        onSelectValueChanged={this.handleEardrumRicCordLengths} value={model.eardrumRicCordLength} />
                </div>
                <div>
                    <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption} isIF={isIF} title="Cord" className="text-sm border-2 border-blue-200"  header="RIC" desc="EardrumRicCordDesc" items={eardrumRicCords}
                        onSelectValueChanged={this.handleEardrumRicCords} value={model.eardrumRicCord} />
                </div>
            </div>
                <div className="w-1/2">
                    <div className="text-xxs text-red-500">
                        <span className="text-xs text-red-600 font-bold">
                            <FormattedMessage id="OrderFillingInstructions" />
                        </span>
                        <FormattedMessage id="EardrumFillingInstructionsContent" />
                    </div>
                    <div colSpan="3" className="text-xxs text-gray-500 italic ">
                        <FormattedMessage id="EardrumOrderFillingInstructionsClaim" />
                    </div>
                </div>
            </div>
        }
        if (version.startsWith('3.0')) {
            let eardrumBteVents = this.filterOptionsByEarmoldVersion(data.eardrumBteVents, versionCode);
            let earmoldBteTubeDiameters = this.filterOptionsByEarmoldVersion(data.earmoldBteTubeDiameters, versionCode);
            let earmoldBteLengths = this.filterOptionsByEarmoldVersion(data.earmoldBteLengths, versionCode); 
            let earmoldBteTubeLengths = this.filterOptionsByEarmoldVersion(data.earmoldBteTubeLengths, versionCode);

            return <div className="flex flex-col gap-6">
                <div className="flex gap-6">
                <div className="">
                        <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption}  className="text-sm border-2 border-purple-200" title="Vent" header="BTE" desc="EardrumRicVentDesc" items={eardrumBteVents}
                        onSelectValueChanged={this.handleEardrumBteVents} value={model.eardrumBteVent} />
                    <div className="text-purple-400"><FormattedMessage id="TubeNotice" /></div>
                </div>
                <div className="flex flex-col gap-6">
                        <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption}  title="EarmoldBteTubeDiamete" className="text-sm border-2 border-purple-200" header="BTE" desc="EarmoldBteTubeDiameteDesc" items={earmoldBteTubeDiameters}
                        onSelectValueChanged={this.handleEarmoldBteTubeDiameters} value={model.earmoldBteTubeDiameter} />
                
                        <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption}  title="EarmoldBteLength" className="text-sm border-2 border-purple-200" header="BTE" desc="EarmoldBteLengthDesc" items={earmoldBteLengths}
                        onSelectValueChanged={this.handleEarmoldBteLengths} value={model.earmoldBteLength} />
                </div>
                <div>               
                        <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption}  title="EarmoldBteTubeLength" className="text-sm border-2 border-purple-200" header="BTE" desc="EarmoldBteTubeLengthDesc" items={earmoldBteTubeLengths}
                        onSelectValueChanged={this.handleEarmoldBteTubeLengths} value={model.earmoldBteTubeLength} />
                </div>
                
                </div>
                <div className="w-1/2">
                    <div className="text-xxs text-red-500">
                        <span className="text-xs text-red-600 font-bold">
                            <FormattedMessage id="OrderFillingInstructions" />
                        </span>
                        <FormattedMessage id="EardrumFillingInstructionsContent" />
                    </div>
                    <div colSpan="3" className="text-xxs text-gray-500 italic ">
                        <FormattedMessage id="EardrumOrderFillingInstructionsClaim" />
                    </div>
                </div>
            </div>
        }

        let eardrumBteVents = this.filterOptionsByEarmoldVersion(data.eardrumBteVents, versionCode);
        return <div className="flex flex-col gap-6"><div className="flex justify-start">
            <EardrumCheckBoxGroup leftRightOption={this.props.leftRightOption} className="w-1/3 text-sm border-2 border-purple-200" title="Vent" header="BTE" desc="EardrumBteVentDesc" items={eardrumBteVents}
                    onSelectValueChanged={this.handleEardrumBteVents} value={model.eardrumBteVent} />            
        </div>
            <div className="w-1/3">
                <div className="text-xxs text-red-500">
                    <span className="text-xs text-red-600 font-bold">
                        <FormattedMessage id="OrderFillingInstructions" />
                    </span>
                    <FormattedMessage id="EardrumFillingInstructionsContent" />
                </div>
                <div colSpan="3" className="text-xxs text-gray-500 italic ">
                    <FormattedMessage id="EardrumOrderFillingInstructionsClaim" />
                </div>
            </div>
        </div>
    }
}
